import LogoDefault from './logo-default.png';

export { default as PurpleLogoCollapsed } from './purple-logo-collapsed.png';
export default LogoDefault;
